import { Box } from "@mui/material";
import React from "react";

// Just a bumper to prevent hitting the bottom of the content
function Footer() {
    return <Box display="flex" sx={{ mt: 10 }} />;
}

export default Footer;
